import React, { Component } from 'react'

import style from './style.css'
export default class ActionBtnIcon extends Component {
    render() {
        return (
            <div
                className={`${style.btn} ${style[this.props.theme]} ${this.props.loading ? style.loading : ''}`}
                style={{
                    fontSize: `${this.props.size || 14}px`,
                    cursor: `${this.props.action ? 'pointer' : ''}`,
                    ...this.props.style
                }}
                onClick={(e) => { if(this.props.action) this.props.action(e) }}>
                {this.props.children}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/SPRINTA/atoms/ActionBtn/index.js